<template>
    <!-- TODO Translate -->
    <dl class="shop-with-confidence">
        <dd
            v-if="ethicallySourcedDiamonds || ethicallySourcedGemstones"
            class="item"
        >
            <Icon
                class="icon"
                icon="star"
            />

            <span class="label">
                {{
                    ethicallySourcedDiamonds
                        ? 'Ethically sourced diamonds'
                        : 'Ethically sourced gemstones'
                }}
            </span>
        </dd>

        <dd
            v-if="ninetyDayReturns"
            class="item"
        >
            <Icon
                class="icon"
                icon="star"
            />

            <span class="label">90 day returns</span>
        </dd>

        <dd
            v-if="priceMatchGuarantee"
            class="item"
        >
            <Icon
                class="icon"
                icon="star"
            />

            <span class="label">Price match guarantee</span>
        </dd>

        <dd
            v-if="qualityGuarantee"
            class="item"
        >
            <Icon
                class="icon"
                icon="star"
            />

            <span class="label">
                Quality guarantee

                <LazyTooltip
                    inline
                    path="/diamond-search/quality-guarantee"
                    :page-type="pageType"
                />
            </span>
        </dd>
    </dl>
</template>

<script lang="ts" setup>
import Icon from '@/components/ui/icon/Icon.vue'
import LazyTooltip from '@/components/layout/tooltip/LazyTooltip.vue'
import type { PageType } from '@/components/cms/component/content/ContentButton.vue'

defineProps<{
    ethicallySourcedGemstones?: boolean
    ethicallySourcedDiamonds?: boolean
    ninetyDayReturns?: boolean
    priceMatchGuarantee?: boolean
    qualityGuarantee?: boolean
    pageType: PageType
}>()
</script>

<style lang="scss" scoped>
.shop-with-confidence {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    border-top: 1px solid $grey-300;
    padding: 20px 0 0 0;
    margin: 20px 0 0 0;

    .item {
        flex-shrink: 0;
        width: 100%;
        margin-bottom: 8px;
        display: flex;
        align-items: center;
        justify-content: left;

        @include min-width(410) {
            width: 50%;
        }

        @include min-width(640) {
            width: 33.333%;
            display: flex;
            justify-content: center;
        }

        .icon {
            margin-right: 8px;
        }

        .label {
            display: flex;
            align-items: center;

            :deep(.tooltip-trigger:after) {
                font-size: 16px;
                margin-top: 4px;
                margin-left: 5px;
            }
        }
    }
}
</style>
